import { api } from "./useApi";

export interface FormaPagamentoTiny {
    descricao: string;
    codigo: string;
}

export interface FormasPagamentoTinyResponse {
    formas: FormaPagamentoTiny[];
    erro?: string;
}

export const tinyApi = () => ({
    buscarFormasPagamento: async (): Promise<FormasPagamentoTinyResponse> => {
        const response = await api.get("/tiny/buscar_formas_pagamento");
        return response.data;
    }
});
